import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useForm } from 'react-hook-form'
import { Button, Card, Col, Container, Form, Image, Row } from 'react-bootstrap'
import {
  selectAuthError,
  selectAuthLoading,
  selectTtl,
} from '@store/slices/auth.slice'
import { AppDispatch } from '@store/store'
import { Navigate } from 'react-router-dom'
import { useTheme } from '@config/theme.config'
import { toast } from 'react-toastify'
import { fetchLoginToken, fetchUserdata, login } from '@store/thunk/auth.thunk'
import { unwrapResult } from '@reduxjs/toolkit'

interface LoginFormData {
  email: string
  login_key: string
}

const LoginPage: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>()
  const isLoggedIn = useSelector(selectTtl)
  const loading = useSelector(selectAuthLoading)
  const error = useSelector(selectAuthError)
  const { theme } = useTheme()
  const { register, handleSubmit } = useForm<LoginFormData>()
  const onLogin = (data: LoginFormData) => {
    if (!loading) {
      dispatch(login({ email: data.email, loginKey: data.login_key }))
        .then(unwrapResult)
        .catch((error) => {
          console.error(error.message)
        })
    }
  }

  const onSendToken = (data: LoginFormData) => {
    if (!loading) {
      dispatch(fetchLoginToken(data.email))
        .then(unwrapResult)
        .then((message: string) => toast.success(message))
        .catch((error) => {
          console.error(error.message)
        })
    }
  }

  if (isLoggedIn) {
    return <Navigate to="/" />
  }

  return (
    <Container
      className="d-flex justify-content-center align-items-center"
      style={{ minHeight: '100vh' }}
    >
      <Row>
        <Col>
          <Image
            src={`${theme}_mode_small.png`}
            alt="Xena logo"
            className="pb-5"
            fluid
          />
          <Card style={{ border: 'none', maxWidth: '320px' }}>
            <Card.Body>
              <Form>
                <Form.Group controlId="username">
                  <Form.Control
                    placeholder={'Email'}
                    type="text"
                    {...register('email', { required: true })}
                  />
                </Form.Group>
                <Form.Group controlId="password" className="mt-3">
                  <Form.Control
                    placeholder={'Přihlašovací klíč'}
                    type="password"
                    {...register('login_key')}
                  />
                </Form.Group>
                <Button
                  variant="primary"
                  type="submit"
                  className="w-100 mt-4"
                  disabled={loading}
                  onClick={handleSubmit(onLogin)}
                >
                  Přihlásit
                </Button>
                <Button
                  variant="secondary"
                  type="submit"
                  className="w-100 mt-2"
                  disabled={loading}
                  onClick={handleSubmit(onSendToken)}
                >
                  Zaslat klíč
                </Button>
              </Form>
              {loading && <p className="text-center mt-3">Loading...</p>}
              {!!error && (
                <p className="text-center mt-3 text-danger">{error}</p>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default LoginPage
